<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
import { page, getById } from '@/api/business/contract'
export default {
  components: {
    MSelectPulldown
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: true,
        page: 1,
        size: 10,
        total: 0
      }
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      this.$emit('change', checkedItem)
    },
    loadData(keyword) {
      return new Promise((resolve, reject) => {
        const params = {
          ...this.queryParams,
          voidStatus: this.$enums.CANCELLATION_STATUS.NOT_CANCELLED.value,
          sort: ['id,desc']
        }
        console.log(keyword)
        page(params).then(res => {
          resolve({
            data: res.data.records
          })
          this.page.total = res.data.total
        }).catch(err => {
          reject(err)
        })
      })
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
    },
    async fetchObject(value) {
      return await getById(value)
    }
  }
}
</script>

<template>
  <m-select-pulldown
    ref="pulldown"
    v-model="localValue"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :fetch-object="fetchObject"
    :page="page"
    :field="{ value: 'id', label: 'contractTitle' }"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    width="600px"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template #content="{ list }">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item padding-sm cursor"
        :class="{
          'active': item.id === localValue
        }"
        @click="$refs.pulldown.onItemChecked(item)"
      >
        <div class="flex justify-between">
          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            <span class="text-bold" style="color: var(--color-text-1);">{{ item.contractTitle }}</span>
            <span class="text-xs" style="display: inline-block;margin-left: 10px;">{{ item.signDate }}</span>
          </div>
          <div style="white-space: nowrap;">
            <span class="label">甲：</span>
            <span>{{ item.partyAName }}</span>
          </div>
        </div>
        <div class="flex justify-between margin-top-xs">
          <div>
            <span class="label">合同号：</span>
            <span>{{ item.contractNo }}</span>
          </div>
          <div style="white-space: nowrap;">
            <span class="label">乙：</span>
            <span>{{ item.partyBName }}</span>
          </div>
        </div>
      </div>
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
.item {
  background: var(--color-fill-2);
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &.active::after {
    content: '';
    position: absolute;
    top: -1.7em;
    left: -1.7em;
    width: 3.5em;
    height: 3.5em;
    transform: rotate(45deg);
    background: var(--color-success);
  }
  &.active::before {
    content: '◉';
    position: absolute;
    top: 0.2em;
    left: 0.2em;
    color: var(--color-white);
    z-index: 1;
  }

  & ~ & {
    margin-top: 12px;
  }
}
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>